<div class="route-component">
    <div class="search-component">
        <h4>
            Tenants
        </h4>

        <div class="line-connector"></div>

        <div class="action-bar">
            <div class="action-bar right">
                <div class="action-container">
                    <button *hasPermission="['Tenant', 'Create']" (click)="addTenant()">
                        Add <i class="fas fa-plus"></i>
                    </button>
                    <button *hasPermission="['Tenant', 'Export']" (click)="downloadTenants(paging)">
                        Download <i class="fas fa-download"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="search-bar">
            <div class="search-bar left">
                <div class="search-container">
                    <input class="search-input" type="text" placeholder="Search..." [(ngModel)]="search" (keydown.enter)="refreshGridData()">
                    <button class="search-button" (click)="refreshGridData()">
                        <i class="fas fa-magnifying-glass"></i>
                    </button>
                </div>
            </div>
        </div>

        <pageable-table
            [items]="tenants"
            [paging]="paging"
            [columns]="getColumnMap()"
            [useSwitch]="false"
            [showEdit]="showEdit || false"
            (editItem)="editTenant($event)"
            (refreshData)="getTenants($event)">
        </pageable-table>
    </div>
</div>